import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type Platform = "ios" | "android" | "web" | null;

interface CryptoState {
  platform: Platform;
  isMobileLayout: boolean | null;
}

const initialState: CryptoState = {
  platform: null,
  isMobileLayout: null,
};

const cryptoSlice = createSlice({
  name: "crypto",
  initialState,
  reducers: {
    setPlatform: (state, action: PayloadAction<Platform>) => {
      state.platform = action.payload;
    },
    setIsMobileLayout: (state, action: PayloadAction<boolean | null>) => {
      state.isMobileLayout = action.payload;
    },
  },
});

export const { setPlatform, setIsMobileLayout } = cryptoSlice.actions;

export default cryptoSlice.reducer;
